module.exports = __webpack_public_path__ + "img/cast.8d405b58.svg";